import { getTestIds } from 'seagull/utils/TestIds';
export const deleteContactModalTextsPath = 'client.contactsDashboard.deleteModal';
export const GetDeleteContactModalTID = (parentTestId)=>getTestIds(parentTestId);
